export const NAMES = [
    "覃",
    "要",
    "覆",
    "見",
    "视",
    "觅",
    "规",
    "观",
    "见",
    "觉",
    "览",
    "角",
    "觝",
    "触",
    "解",
    "褚",
    "褓",
    "褒",
    "褐",
    "襄",
    "襁",
    "西",
    "袖",
    "袛",
    "袜",
    "袁",
    "袂",
    "袅",
    "袄",
    "袈",
    "袋",
    "袍",
    "袱",
    "袤",
    "被",
    "袭",
    "裔",
    "裕",
    "裟",
    "裘",
    "裙",
    "装",
    "裆",
    "裁",
    "裂",
    "裏",
    "裳",
    "裱",
    "裸",
    "裹",
    "裤",
    "衙",
    "衔",
    "街",
    "行",
    "血",
    "衷",
    "衲",
    "衰",
    "衬",
    "衫",
    "表",
    "衩",
    "补",
    "衣",
    "衡",
    "讥",
    "认",
    "计",
    "订",
    "训",
    "讯",
    "议",
    "让",
    "讨",
    "讪",
    "讴",
    "讶",
    "讷",
    "记",
    "讲",
    "讳",
    "讼",
    "讽",
    "设",
    "访",
    "许",
    "论",
    "诡",
    "诣",
    "询",
    "该",
    "诧",
    "详",
    "诩",
    "诨",
    "诫",
    "语",
    "误",
    "诱",
    "诲",
    "诳",
    "说",
    "诵",
    "诶",
    "请",
    "诸",
    "诺",
    "读",
    "诽",
    "课",
    "证",
    "诀",
    "识",
    "诅",
    "评",
    "诊",
    "诉",
    "诈",
    "诏",
    "词",
    "诌",
    "译",
    "诗",
    "试",
    "诚",
    "诞",
    "诟",
    "话",
    "譬",
    "警",
    "誓",
    "誉",
    "誊",
    "諾",
    "訇",
    "言",
    "詹",
    "話",
    "跎",
    "跌",
    "跃",
    "跟",
    "距",
    "跑",
    "跬",
    "路",
    "跪",
    "跤",
    "跺",
    "践",
    "跳",
    "趋",
    "越",
    "趁",
    "超",
    "趟",
    "趣",
    "足",
    "趴",
    "资",
    "赂",
    "赃",
    "赏",
    "赌",
    "赋",
    "赈",
    "赖",
    "赔",
    "赐",
    "赞",
    "赝",
    "赛",
    "赚",
    "赤",
    "赦",
    "赧",
    "赠",
    "赡",
    "赢",
    "赭",
    "赫",
    "赵",
    "赴",
    "起",
    "赶",
    "走",
    "赳",
    "贏",
    "负",
    "贞",
    "贝",
    "贡",
    "财",
    "责",
    "贤",
    "败",
    "账",
    "货",
    "质",
    "贩",
    "贪",
    "贫",
    "贬",
    "购",
    "贯",
    "贱",
    "贰",
    "贵",
    "贴",
    "贷",
    "费",
    "贸",
    "贻",
    "贺",
    "贼",
    "贿",
    "贾",
    "賑",
    "賊",
    "賀",
    "賦",
    "貘",
    "貍",
    "貌",
    "貂",
    "費",
    "豚",
    "豆",
    "豁",
    "豌",
    "豉",
    "豺",
    "豹",
    "象",
    "豪",
    "豫",
    "谑",
    "谐",
    "谓",
    "谕",
    "谔",
    "谗",
    "谙",
    "谛",
    "谚",
    "谜",
    "谁",
    "调",
    "谈",
    "谊",
    "谋",
    "谎",
    "谏",
    "谱",
    "谷",
    "谴",
    "谢",
    "谣",
    "谡",
    "谦",
    "谧",
    "谥",
    "谨",
    "谭",
    "迩",
    "迫",
    "迪",
    "迭",
    "迢",
    "迤",
    "迦",
    "迹",
    "追",
    "述",
    "迷",
    "迈",
    "迎",
    "迂",
    "迁",
    "过",
    "迅",
    "迄",
    "进",
    "还",
    "这",
    "连",
    "迟",
    "远",
    "违",
    "运",
    "近",
    "返",
    "辩",
    "辨",
    "辫",
    "辣",
    "辽",
    "达",
    "边",
    "辰",
    "辱",
    "辍",
    "辉",
    "辈",
    "辆",
    "辅",
    "较",
    "辞",
    "辟",
    "辜",
    "辛",
    "辙",
    "辖",
    "输",
    "辐",
    "辑",
    "车",
    "轧",
    "轨",
    "轩",
    "转",
    "轮",
    "软",
    "轰",
    "轴",
    "轶",
    "轻",
    "载",
    "轿",
    "躺",
    "躹",
    "躲",
    "躯",
    "躬",
    "身",
    "蹬",
    "蹈",
    "蹉",
    "蹊",
    "蹋",
    "踱",
    "踼",
    "踹",
    "踢",
    "踪",
    "踩",
    "踞",
    "踏",
    "踊",
    "脚",
    "脓",
    "脑",
    "脐",
    "脖",
    "脊",
    "脉",
    "脏",
    "脂",
    "脆",
    "脸",
    "脱",
    "腕",
    "腔",
    "腑",
    "腐",
    "腌",
    "腊",
    "腋",
    "腆",
    "腼",
    "腿",
    "腾",
    "腹",
    "腺",
    "腱",
    "腰",
    "腳",
    "腥",
    "膑",
    "膛",
    "膘",
    "膝",
    "膀",
    "膊",
    "膈",
    "膏",
    "膳",
    "膺",
    "膨",
    "臆",
    "臂",
    "臀",
    "臊",
    "致",
    "至",
    "臼",
    "臻",
    "臣",
    "臭",
    "臬",
    "而",
    "耍",
    "耀",
    "老",
    "考",
    "者",
    "耙",
    "耘",
    "耐",
    "耕",
    "耗",
    "耻",
    "耸",
    "耿",
    "耽",
    "耳",
    "耶",
    "职",
    "聊",
    "聋",
    "聆",
    "聘",
    "聚",
    "联",
    "聪",
    "肃",
    "肄",
    "肇",
    "肆",
    "肉",
    "肌",
    "肖",
    "肚",
    "肛",
    "肝",
    "肢",
    "股",
    "肠",
    "肥",
    "肤",
    "肩",
    "肯",
    "肮",
    "育",
    "肴",
    "肺",
    "肾",
    "肿",
    "胄",
    "胆",
    "胁",
    "胀",
    "胃",
    "背",
    "胎",
    "胖",
    "胜",
    "胞",
    "胚",
    "胥",
    "胤",
    "胡",
    "胯",
    "胭",
    "胫",
    "能",
    "胸",
    "乾",
    "茹",
    "茴",
    "茶",
    "乳",
    "乱",
    "买",
    "茬",
    "茯",
    "茫",
    "书",
    "习",
    "乡",
    "九",
    "也",
    "乞",
    "茜",
    "乙",
    "乘",
    "茗",
    "乔",
    "乖",
    "乐",
    "乓",
    "乒",
    "乌",
    "乍",
    "乎",
    "乏",
    "义",
    "之",
    "久",
    "茄",
    "茅",
    "茂",
    "范",
    "乃",
    "茁",
    "主",
    "为",
    "丹",
    "丸",
    "举",
    "丽",
    "串",
    "丰",
    "荷",
    "临",
    "个",
    "丫",
    "荫",
    "药",
    "中",
    "丢",
    "荡",
    "荣",
    "荤",
    "丧",
    "两",
    "荧",
    "严",
    "丙",
    "荚",
    "丘",
    "丛",
    "业",
    "丝",
    "东",
    "丟",
    "丞",
    "丑",
    "丐",
    "荒",
    "专",
    "荑",
    "荐",
    "且",
    "世",
    "荔",
    "丈",
    "三",
    "上",
    "下",
    "不",
    "与",
    "一",
    "丁",
    "荀",
    "七",
    "荆",
    "万",
    "莴",
    "件",
    "价",
    "仵",
    "获",
    "仲",
    "莱",
    "莲",
    "仰",
    "仿",
    "莽",
    "份",
    "莹",
    "任",
    "莺",
    "以",
    "令",
    "代",
    "莬",
    "们",
    "仪",
    "莫",
    "仔",
    "仕",
    "他",
    "仗",
    "仑",
    "莓",
    "仓",
    "莜",
    "付",
    "仙",
    "莘",
    "仅",
    "仄",
    "莆",
    "仇",
    "仆",
    "仁",
    "什",
    "仍",
    "莎",
    "从",
    "介",
    "莉",
    "今",
    "亲",
    "亳",
    "菲",
    "人",
    "亿",
    "亢",
    "菠",
    "亡",
    "产",
    "亦",
    "亥",
    "交",
    "享",
    "菩",
    "亩",
    "亨",
    "亮",
    "亭",
    "京",
    "云",
    "互",
    "五",
    "井",
    "亚",
    "些",
    "菟",
    "菜",
    "亁",
    "菁",
    "菇",
    "争",
    "予",
    "菊",
    "事",
    "菏",
    "二",
    "亏",
    "菌",
    "于",
    "般",
    "航",
    "佩",
    "你",
    "舢",
    "佣",
    "使",
    "船",
    "佻",
    "舷",
    "舶",
    "舵",
    "佰",
    "舱",
    "佳",
    "舰",
    "低",
    "舌",
    "舍",
    "住",
    "位",
    "但",
    "舅",
    "舜",
    "舟",
    "舞",
    "作",
    "佛",
    "佚",
    "佗",
    "舔",
    "何",
    "体",
    "佑",
    "舒",
    "佐",
    "伪",
    "良",
    "伯",
    "传",
    "伤",
    "伥",
    "伦",
    "艺",
    "伸",
    "伽",
    "艾",
    "似",
    "艳",
    "色",
    "估",
    "艰",
    "伴",
    "伊",
    "伏",
    "伍",
    "企",
    "艄",
    "艇",
    "艘",
    "会",
    "伙",
    "优",
    "伞",
    "休",
    "伐",
    "众",
    "芦",
    "芥",
    "信",
    "芯",
    "俭",
    "俯",
    "芭",
    "芬",
    "修",
    "芳",
    "俱",
    "花",
    "俳",
    "俾",
    "芽",
    "俸",
    "俺",
    "芸",
    "芹",
    "俄",
    "促",
    "节",
    "俏",
    "芍",
    "俊",
    "芋",
    "芊",
    "俗",
    "俐",
    "芒",
    "芝",
    "保",
    "芙",
    "俘",
    "侠",
    "侣",
    "苦",
    "侧",
    "若",
    "侦",
    "苯",
    "侯",
    "侮",
    "英",
    "苷",
    "侵",
    "苹",
    "便",
    "侃",
    "苇",
    "侄",
    "例",
    "侈",
    "苍",
    "侏",
    "苏",
    "侍",
    "侓",
    "苑",
    "苔",
    "苗",
    "供",
    "苛",
    "苜",
    "苟",
    "依",
    "蕊",
    "蕉",
    "蔓",
    "蔑",
    "蔷",
    "蔽",
    "蔼",
    "蔡",
    "蔬",
    "藏",
    "藉",
    "藻",
    "藤",
    "薙",
    "薇",
    "薄",
    "薰",
    "薪",
    "薯",
    "著",
    "葛",
    "董",
    "葡",
    "葬",
    "葭",
    "葫",
    "葵",
    "葱",
    "萃",
    "萄",
    "萋",
    "萌",
    "萝",
    "萧",
    "萤",
    "营",
    "萨",
    "落",
    "蓉",
    "蓝",
    "蓬",
    "蓦",
    "蓿",
    "蒂",
    "蒙",
    "蒜",
    "蒺",
    "蒸",
    "蒹",
    "蒿",
    "蝴",
    "蝶",
    "蝼",
    "蝠",
    "蝣",
    "蝗",
    "蝙",
    "蝇",
    "蝉",
    "蝎",
    "蝌",
    "蜻",
    "蜗",
    "蜜",
    "蜙",
    "蜘",
    "蜇",
    "蜂",
    "蜃",
    "蜀",
    "蜊",
    "蜈",
    "蜉",
    "蟹",
    "蟾",
    "蟑",
    "蟋",
    "蟀",
    "螳",
    "螨",
    "螫",
    "螟",
    "融",
    "螂",
    "虡",
    "虫",
    "虱",
    "虻",
    "虾",
    "虽",
    "虎",
    "虏",
    "虑",
    "虐",
    "虚",
    "蛮",
    "蛹",
    "蛾",
    "蛉",
    "蛋",
    "蛊",
    "蛏",
    "蛀",
    "蛇",
    "蛆",
    "蛙",
    "蛛",
    "蛟",
    "蛐",
    "蛔",
    "蚩",
    "蚨",
    "蚤",
    "蚣",
    "蚴",
    "蚱",
    "蚌",
    "蚊",
    "蚁",
    "蚀",
    "蚝",
    "蚕",
    "蚓",
    "频",
    "颐",
    "颓",
    "颔",
    "颗",
    "颖",
    "题",
    "颛",
    "额",
    "颜",
    "颀",
    "颁",
    "颂",
    "预",
    "颅",
    "领",
    "嗅",
    "颇",
    "颈",
    "颊",
    "喷",
    "喱",
    "喽",
    "喻",
    "喪",
    "飒",
    "食",
    "喜",
    "飞",
    "飙",
    "飘",
    "喙",
    "喆",
    "善",
    "喃",
    "喏",
    "风",
    "喊",
    "喉",
    "啸",
    "啪",
    "啬",
    "啤",
    "啜",
    "啐",
    "頂",
    "商",
    "啄",
    "顾",
    "顿",
    "顽",
    "顺",
    "须",
    "项",
    "顶",
    "顷",
    "页",
    "唯",
    "售",
    "唤",
    "唐",
    "題",
    "唇",
    "哥",
    "哪",
    "馨",
    "哭",
    "哲",
    "哺",
    "哀",
    "品",
    "馆",
    "馅",
    "馋",
    "哉",
    "馈",
    "首",
    "香",
    "咦",
    "咨",
    "咱",
    "咸",
    "和",
    "咏",
    "咒",
    "咜",
    "咚",
    "周",
    "餮",
    "呻",
    "呼",
    "命",
    "味",
    "呈",
    "告",
    "呆",
    "员",
    "餐",
    "呕",
    "呖",
    "饭",
    "启",
    "饯",
    "饮",
    "听",
    "含",
    "饨",
    "吩",
    "饥",
    "否",
    "吠",
    "饼",
    "吾",
    "饿",
    "吻",
    "吸",
    "饺",
    "吹",
    "吶",
    "饶",
    "吴",
    "饷",
    "吵",
    "饰",
    "饱",
    "饲",
    "吱",
    "名",
    "同",
    "吏",
    "后",
    "吉",
    "合",
    "吊",
    "各",
    "吃",
    "吝",
    "吞",
    "吟",
    "君",
    "吕",
    "吖",
    "饕",
    "吗",
    "向",
    "吒",
    "吓",
    "骗",
    "骑",
    "骜",
    "骚",
    "骄",
    "骆",
    "骇",
    "骂",
    "验",
    "城",
    "骏",
    "骋",
    "骰",
    "骼",
    "培",
    "骸",
    "基",
    "骨",
    "垒",
    "髓",
    "高",
    "垂",
    "垃",
    "髅",
    "垄",
    "型",
    "髻",
    "垠",
    "垢",
    "垣",
    "髦",
    "垩",
    "垫",
    "坞",
    "坟",
    "坝",
    "坚",
    "坛",
    "块",
    "坐",
    "坑",
    "坏",
    "坎",
    "坍",
    "坊",
    "均",
    "坂",
    "址",
    "坼",
    "坯",
    "坨",
    "坦",
    "坡",
    "坠",
    "土",
    "圈",
    "圹",
    "驻",
    "驸",
    "场",
    "驹",
    "驾",
    "驿",
    "圾",
    "驽",
    "地",
    "驰",
    "驱",
    "驶",
    "驴",
    "在",
    "驯",
    "驭",
    "马",
    "圣",
    "圧",
    "囊",
    "回",
    "四",
    "囚",
    "团",
    "因",
    "园",
    "国",
    "固",
    "嚣",
    "鯨",
    "噌",
    "噩",
    "器",
    "鬼",
    "嘉",
    "魏",
    "魂",
    "魄",
    "魔",
    "冽",
    "冻",
    "冷",
    "冶",
    "冰",
    "决",
    "冲",
    "冬",
    "冯",
    "冤",
    "冥",
    "冠",
    "鳝",
    "鳞",
    "农",
    "军",
    "写",
    "冗",
    "鳔",
    "冕",
    "鳗",
    "冒",
    "鳐",
    "册",
    "再",
    "冈",
    "冉",
    "鳄",
    "内",
    "冀",
    "鳃",
    "凹",
    "凸",
    "击",
    "出",
    "鲸",
    "函",
    "凿",
    "凰",
    "鲲",
    "凳",
    "鲷",
    "鲶",
    "凶",
    "鲫",
    "鲨",
    "凭",
    "凯",
    "几",
    "凡",
    "凤",
    "鲤",
    "凛",
    "鲛",
    "鲜",
    "凝",
    "凑",
    "凉",
    "减",
    "鲍",
    "凌",
    "鲁",
    "净",
    "准",
    "凄",
    "鱼",
    "儿",
    "兰",
    "共",
    "关",
    "兴",
    "兵",
    "其",
    "具",
    "典",
    "养",
    "兼",
    "兽",
    "兢",
    "入",
    "內",
    "全",
    "八",
    "六",
    "公",
    "兮",
    "兑",
    "兔",
    "党",
    "元",
    "允",
    "兇",
    "兆",
    "充",
    "兄",
    "克",
    "光",
    "先",
    "免",
    "傾",
    "傻",
    "傲",
    "傍",
    "傅",
    "僧",
    "僻",
    "僵",
    "像",
    "倦",
    "倾",
    "值",
    "债",
    "倍",
    "倌",
    "個",
    "倔",
    "借",
    "候",
    "倚",
    "健",
    "偷",
    "偿",
    "偃",
    "假",
    "偏",
    "做",
    "停",
    "厚",
    "默",
    "黛",
    "厘",
    "原",
    "黑",
    "厕",
    "压",
    "厉",
    "黍",
    "厌",
    "黎",
    "黏",
    "厂",
    "黄",
    "历",
    "厄",
    "厅",
    "去",
    "县",
    "厨",
    "厮",
    "厢",
    "厦",
    "叟",
    "麟",
    "叛",
    "叙",
    "变",
    "受",
    "取",
    "叔",
    "发",
    "麒",
    "双",
    "反",
    "及",
    "友",
    "又",
    "叉",
    "麋",
    "参",
    "麻",
    "叹",
    "司",
    "麸",
    "叵",
    "号",
    "叶",
    "台",
    "右",
    "史",
    "召",
    "叮",
    "可",
    "叨",
    "叩",
    "只",
    "叫",
    "古",
    "麦",
    "句",
    "另",
    "叠",
    "口",
    "匐",
    "化",
    "北",
    "匕",
    "鹘",
    "匙",
    "鹞",
    "匝",
    "鹃",
    "匀",
    "鹂",
    "鹅",
    "匆",
    "鹄",
    "包",
    "鹉",
    "鹊",
    "匈",
    "匍",
    "鹏",
    "鹰",
    "匹",
    "区",
    "医",
    "鹿",
    "匾",
    "匿",
    "匡",
    "匠",
    "匣",
    "鹧",
    "鹦",
    "鹤",
    "鹫",
    "匪",
    "鹭",
    "匮",
    "卖",
    "南",
    "单",
    "卒",
    "卓",
    "卑",
    "卞",
    "卜",
    "鸟",
    "博",
    "升",
    "千",
    "十",
    "协",
    "华",
    "半",
    "卉",
    "午",
    "却",
    "卵",
    "卷",
    "鸵",
    "印",
    "鸳",
    "危",
    "即",
    "鸾",
    "鸿",
    "卿",
    "鸽",
    "卸",
    "鸦",
    "卤",
    "卧",
    "鸥",
    "卦",
    "鸣",
    "卡",
    "占",
    "鸢",
    "鸡",
    "卢",
    "鸠",
    "鸯",
    "鸭",
    "卯",
    "鸬",
    "鸪",
    "卫",
    "鸩",
    "劈",
    "力",
    "劝",
    "功",
    "办",
    "努",
    "劫",
    "动",
    "助",
    "劣",
    "加",
    "务",
    "势",
    "劽",
    "劳",
    "励",
    "劵",
    "龌",
    "龊",
    "勉",
    "龈",
    "勋",
    "龄",
    "勇",
    "勃",
    "龟",
    "募",
    "龙",
    "勒",
    "勤",
    "勿",
    "勾",
    "勺",
    "刁",
    "刀",
    "刃",
    "切",
    "分",
    "刊",
    "刑",
    "齐",
    "划",
    "列",
    "刘",
    "则",
    "刚",
    "创",
    "初",
    "删",
    "判",
    "别",
    "利",
    "刮",
    "到",
    "制",
    "刷",
    "刺",
    "刻",
    "券",
    "刹",
    "齿",
    "剁",
    "剂",
    "前",
    "剌",
    "削",
    "剔",
    "剖",
    "剑",
    "鼓",
    "剜",
    "剧",
    "剥",
    "鼠",
    "副",
    "鼬",
    "剪",
    "剩",
    "割",
    "剿",
    "剽",
    "鼻",
    "嵠",
    "逢",
    "造",
    "逸",
    "逾",
    "逼",
    "选",
    "嵋",
    "逊",
    "逍",
    "透",
    "嵌",
    "送",
    "退",
    "逃",
    "适",
    "嵇",
    "逅",
    "逆",
    "通",
    "逛",
    "逝",
    "逞",
    "速",
    "逐",
    "逑",
    "途",
    "逗",
    "崭",
    "遮",
    "遭",
    "崩",
    "遨",
    "遥",
    "遣",
    "遢",
    "避",
    "崽",
    "遍",
    "崇",
    "崆",
    "遇",
    "遁",
    "崂",
    "遂",
    "崛",
    "遛",
    "崖",
    "崔",
    "遗",
    "遐",
    "遑",
    "遒",
    "道",
    "邢",
    "那",
    "巡",
    "巢",
    "邦",
    "工",
    "左",
    "巧",
    "邪",
    "巨",
    "巩",
    "巫",
    "邮",
    "差",
    "己",
    "邱",
    "邰",
    "已",
    "巴",
    "巷",
    "邻",
    "巾",
    "邀",
    "邂",
    "巅",
    "邈",
    "邋",
    "巍",
    "邑",
    "邓",
    "邙",
    "州",
    "川",
    "郡",
    "郭",
    "部",
    "都",
    "嶂",
    "郁",
    "郎",
    "郊",
    "郑",
    "嶙",
    "屿",
    "山",
    "屯",
    "屡",
    "屠",
    "履",
    "鄙",
    "属",
    "屑",
    "展",
    "屉",
    "屈",
    "屋",
    "届",
    "屌",
    "屏",
    "屎",
    "屁",
    "局",
    "鄂",
    "层",
    "居",
    "尾",
    "尿",
    "尼",
    "尽",
    "酿",
    "尺",
    "酸",
    "尸",
    "尹",
    "尴",
    "酷",
    "酱",
    "就",
    "酬",
    "尬",
    "酥",
    "尧",
    "尤",
    "酣",
    "尝",
    "尘",
    "尚",
    "尔",
    "酗",
    "尖",
    "酒",
    "少",
    "酐",
    "小",
    "配",
    "酌",
    "酋",
    "尉",
    "酊",
    "尊",
    "射",
    "将",
    "封",
    "峰",
    "峻",
    "峦",
    "峥",
    "峪",
    "峨",
    "醒",
    "峒",
    "醐",
    "峙",
    "醚",
    "醂",
    "醇",
    "醋",
    "醉",
    "醍",
    "岷",
    "岵",
    "岳",
    "岱",
    "岸",
    "岢",
    "岣",
    "岬",
    "岭",
    "岩",
    "岔",
    "岗",
    "岖",
    "岑",
    "岐",
    "金",
    "岜",
    "釜",
    "岙",
    "岛",
    "岚",
    "采",
    "岁",
    "岂",
    "野",
    "岌",
    "量",
    "里",
    "重",
    "释",
    "釉",
    "彈",
    "彝",
    "彗",
    "录",
    "归",
    "当",
    "彭",
    "彬",
    "彩",
    "彪",
    "彥",
    "彤",
    "彦",
    "鈡",
    "形",
    "彼",
    "役",
    "彻",
    "彷",
    "彰",
    "影",
    "弋",
    "弊",
    "弈",
    "式",
    "弃",
    "异",
    "开",
    "鉄",
    "弄",
    "弛",
    "弘",
    "弟",
    "弓",
    "弑",
    "弗",
    "引",
    "弩",
    "弯",
    "张",
    "弥",
    "弧",
    "弦",
    "弹",
    "强",
    "弼",
    "弱",
    "鉴",
    "強",
    "忆",
    "必",
    "心",
    "忏",
    "忌",
    "忍",
    "忉",
    "志",
    "忖",
    "忑",
    "忐",
    "忙",
    "忘",
    "忤",
    "忧",
    "忠",
    "忡",
    "快",
    "念",
    "忱",
    "忽",
    "忿",
    "忸",
    "忻",
    "往",
    "征",
    "徇",
    "径",
    "待",
    "徊",
    "律",
    "很",
    "徉",
    "後",
    "徒",
    "徐",
    "得",
    "徕",
    "徙",
    "徘",
    "徜",
    "御",
    "徨",
    "循",
    "微",
    "徳",
    "徵",
    "德",
    "徽",
    "幛",
    "幕",
    "幅",
    "幄",
    "幂",
    "广",
    "幼",
    "幽",
    "幺",
    "幻",
    "幸",
    "并",
    "年",
    "干",
    "平",
    "錦",
    "幢",
    "幡",
    "帘",
    "帚",
    "帛",
    "帜",
    "帝",
    "帐",
    "帑",
    "帔",
    "帕",
    "帖",
    "师",
    "希",
    "帏",
    "币",
    "布",
    "市",
    "帅",
    "帆",
    "常",
    "帼",
    "帽",
    "帮",
    "席",
    "帧",
    "带",
    "廓",
    "廉",
    "廊",
    "廷",
    "延",
    "廿",
    "建",
    "廪",
    "庐",
    "库",
    "底",
    "应",
    "店",
    "庖",
    "庙",
    "庚",
    "府",
    "废",
    "庞",
    "庄",
    "庆",
    "庇",
    "鏊",
    "床",
    "序",
    "康",
    "庶",
    "庵",
    "庸",
    "庾",
    "度",
    "座",
    "庭",
    "大",
    "夭",
    "央",
    "天",
    "鑫",
    "夫",
    "太",
    "头",
    "夷",
    "失",
    "夸",
    "夺",
    "备",
    "处",
    "夀",
    "夏",
    "复",
    "外",
    "夕",
    "够",
    "夜",
    "多",
    "夙",
    "奠",
    "奢",
    "奥",
    "奧",
    "女",
    "奴",
    "奶",
    "奸",
    "她",
    "好",
    "奂",
    "奇",
    "奄",
    "奋",
    "奉",
    "奈",
    "奏",
    "奎",
    "契",
    "奖",
    "套",
    "奔",
    "奕",
    "奚",
    "奘",
    "铮",
    "妮",
    "铬",
    "妯",
    "铭",
    "妨",
    "妩",
    "妪",
    "妥",
    "铠",
    "链",
    "妾",
    "妹",
    "铺",
    "妻",
    "铸",
    "银",
    "铲",
    "妲",
    "铰",
    "妍",
    "妊",
    "妈",
    "妆",
    "铄",
    "铅",
    "妇",
    "妄",
    "铆",
    "如",
    "铀",
    "铁",
    "妃",
    "铂",
    "铃",
    "妁",
    "铝",
    "妞",
    "铜",
    "铙",
    "妙",
    "铛",
    "妗",
    "妖",
    "妒",
    "铐",
    "姨",
    "钨",
    "钩",
    "姫",
    "姬",
    "钮",
    "钢",
    "钠",
    "姣",
    "钦",
    "钧",
    "姥",
    "钥",
    "钻",
    "姹",
    "钿",
    "钾",
    "姿",
    "钼",
    "钳",
    "钱",
    "钰",
    "钵",
    "针",
    "姊",
    "始",
    "钉",
    "姆",
    "钙",
    "姚",
    "钛",
    "钚",
    "姘",
    "钝",
    "钜",
    "钟",
    "姝",
    "钞",
    "姜",
    "姓",
    "姑",
    "钓",
    "姐",
    "钒",
    "姗",
    "钗",
    "委",
    "堵",
    "镰",
    "堰",
    "长",
    "堤",
    "镡",
    "堡",
    "镣",
    "镭",
    "镯",
    "堪",
    "堕",
    "堑",
    "镓",
    "镐",
    "镜",
    "堙",
    "镇",
    "堆",
    "镂",
    "堂",
    "镀",
    "锱",
    "锹",
    "塾",
    "锦",
    "填",
    "塑",
    "锐",
    "锑",
    "塔",
    "塘",
    "错",
    "塞",
    "锂",
    "锁",
    "销",
    "锆",
    "锅",
    "锄",
    "锋",
    "锉",
    "锈",
    "塌",
    "锌",
    "闽",
    "闾",
    "闹",
    "墻",
    "闸",
    "闻",
    "闺",
    "闵",
    "间",
    "闷",
    "闶",
    "墳",
    "闱",
    "闰",
    "闳",
    "闲",
    "墮",
    "闭",
    "问",
    "闯",
    "门",
    "闩",
    "闪",
    "墨",
    "墩",
    "墜",
    "墟",
    "增",
    "墙",
    "増",
    "墓",
    "墉",
    "墅",
    "境",
    "壹",
    "壳",
    "声",
    "壶",
    "士",
    "壮",
    "壬",
    "閣",
    "壤",
    "壑",
    "壕",
    "壁",
    "門",
    "壅",
    "陀",
    "陂",
    "际",
    "附",
    "陇",
    "陆",
    "陈",
    "嬉",
    "陋",
    "降",
    "陌",
    "限",
    "陕",
    "陛",
    "院",
    "陡",
    "除",
    "陪",
    "险",
    "陨",
    "陶",
    "嬴",
    "陷",
    "陴",
    "陵",
    "阅",
    "阁",
    "阀",
    "阎",
    "阉",
    "阈",
    "阔",
    "字",
    "阕",
    "阖",
    "孔",
    "孕",
    "子",
    "阜",
    "孟",
    "孜",
    "队",
    "孝",
    "孚",
    "阙",
    "存",
    "孙",
    "孤",
    "学",
    "季",
    "孩",
    "阪",
    "孪",
    "阶",
    "孵",
    "阴",
    "阵",
    "防",
    "孰",
    "阳",
    "孱",
    "阿",
    "孽",
    "阻",
    "孺",
    "雉",
    "宋",
    "守",
    "安",
    "雌",
    "宏",
    "雍",
    "完",
    "雎",
    "雏",
    "雀",
    "它",
    "雁",
    "宁",
    "雄",
    "宇",
    "雅",
    "集",
    "宄",
    "宅",
    "雇",
    "宛",
    "定",
    "宙",
    "官",
    "实",
    "宝",
    "宜",
    "雕",
    "宗",
    "宕",
    "雪",
    "雨",
    "宫",
    "雯",
    "宮",
    "宠",
    "审",
    "客",
    "宣",
    "室",
    "容",
    "宽",
    "雾",
    "宿",
    "宾",
    "雳",
    "雲",
    "宰",
    "害",
    "雷",
    "宵",
    "零",
    "宴",
    "家",
    "隍",
    "富",
    "随",
    "隈",
    "隋",
    "寉",
    "密",
    "寇",
    "寄",
    "隆",
    "寅",
    "寂",
    "察",
    "寞",
    "障",
    "寝",
    "隙",
    "隘",
    "隔",
    "寓",
    "寒",
    "隐",
    "寑",
    "寐",
    "寮",
    "寨",
    "隨",
    "寤",
    "寥",
    "隧",
    "寡",
    "寢",
    "导",
    "难",
    "寿",
    "隽",
    "隼",
    "对",
    "寸",
    "寻",
    "寺",
    "隶",
    "青",
    "靓",
    "娑",
    "娓",
    "靖",
    "娘",
    "靛",
    "静",
    "非",
    "威",
    "娃",
    "娄",
    "靈",
    "娌",
    "娲",
    "娱",
    "靳",
    "靴",
    "娶",
    "靶",
    "娼",
    "娣",
    "靡",
    "靠",
    "面",
    "靥",
    "革",
    "靬",
    "霖",
    "婕",
    "霓",
    "霞",
    "霜",
    "婚",
    "震",
    "霆",
    "霄",
    "婀",
    "需",
    "霍",
    "婉",
    "霉",
    "婊",
    "婶",
    "婷",
    "婴",
    "婵",
    "霰",
    "露",
    "婿",
    "婼",
    "霾",
    "霸",
    "霹",
    "婧",
    "婢",
    "婪",
    "媒",
    "媳",
    "音",
    "韵",
    "韩",
    "韬",
    "韭",
    "韦",
    "韧",
    "鞘",
    "鞍",
    "嫉",
    "鞋",
    "鞅",
    "鞭",
    "鞠",
    "暮",
    "暴",
    "暂",
    "暄",
    "暑",
    "暖",
    "暗",
    "暝",
    "曦",
    "更",
    "曰",
    "曲",
    "曳",
    "曼",
    "曾",
    "替",
    "書",
    "曹",
    "曌",
    "曈",
    "曜",
    "曝",
    "曙",
    "昨",
    "昭",
    "是",
    "映",
    "春",
    "昧",
    "昼",
    "显",
    "昱",
    "昵",
    "昴",
    "昊",
    "明",
    "昏",
    "昌",
    "昂",
    "昀",
    "昇",
    "昄",
    "昙",
    "星",
    "易",
    "昕",
    "昔",
    "普",
    "景",
    "晨",
    "晩",
    "晤",
    "晦",
    "晧",
    "晢",
    "晾",
    "智",
    "晴",
    "晶",
    "晰",
    "晳",
    "晏",
    "晌",
    "晋",
    "晃",
    "晁",
    "晞",
    "晚",
    "晗",
    "晖",
    "晕",
    "晔",
    "晓",
    "晒",
    "枳",
    "枰",
    "架",
    "枷",
    "枻",
    "枸",
    "枣",
    "枢",
    "枥",
    "枫",
    "枪",
    "枯",
    "枭",
    "枕",
    "林",
    "枚",
    "果",
    "枝",
    "极",
    "构",
    "枇",
    "枉",
    "柴",
    "柳",
    "柱",
    "查",
    "柠",
    "柯",
    "柬",
    "柔",
    "某",
    "柑",
    "柒",
    "染",
    "柜",
    "柝",
    "柚",
    "柛",
    "柄",
    "柏",
    "机",
    "朽",
    "朱",
    "朵",
    "朴",
    "未",
    "末",
    "木",
    "术",
    "本",
    "札",
    "朦",
    "望",
    "朝",
    "期",
    "朕",
    "朔",
    "朗",
    "月",
    "有",
    "朊",
    "朋",
    "服",
    "最",
    "板",
    "松",
    "杻",
    "杵",
    "杳",
    "杰",
    "杮",
    "杯",
    "杭",
    "杨",
    "来",
    "杠",
    "条",
    "杜",
    "束",
    "杞",
    "杖",
    "村",
    "材",
    "李",
    "杏",
    "杈",
    "杉",
    "杀",
    "杂",
    "权",
    "撇",
    "撕",
    "撒",
    "撑",
    "撞",
    "撤",
    "播",
    "撬",
    "撩",
    "撵",
    "撰",
    "撼",
    "撸",
    "撺",
    "擅",
    "擎",
    "操",
    "擒",
    "擘",
    "擦",
    "搏",
    "搅",
    "搂",
    "搀",
    "搁",
    "搞",
    "搜",
    "搔",
    "搓",
    "搐",
    "搬",
    "搭",
    "搪",
    "携",
    "摊",
    "摁",
    "摆",
    "摇",
    "摄",
    "摘",
    "摔",
    "摩",
    "摧",
    "摹",
    "摸",
    "摺",
    "斗",
    "斐",
    "斑",
    "斜",
    "斟",
    "料",
    "文",
    "斌",
    "斋",
    "新",
    "於",
    "施",
    "方",
    "斧",
    "斥",
    "斤",
    "斯",
    "断",
    "斩",
    "旖",
    "旗",
    "旁",
    "旅",
    "旋",
    "旌",
    "族",
    "旱",
    "时",
    "旷",
    "旺",
    "旽",
    "既",
    "无",
    "旧",
    "旦",
    "日",
    "早",
    "旨",
    "旯",
    "旮",
    "旭",
    "旬",
    "攘",
    "攒",
    "攀",
    "政",
    "放",
    "攻",
    "改",
    "攸",
    "收",
    "支",
    "教",
    "敛",
    "敝",
    "敞",
    "救",
    "敕",
    "敖",
    "效",
    "敌",
    "敏",
    "故",
    "敲",
    "数",
    "敷",
    "整",
    "敬",
    "敢",
    "散",
    "敦",
    "拯",
    "拮",
    "择",
    "拨",
    "拥",
    "拧",
    "拦",
    "拣",
    "拢",
    "拼",
    "拽",
    "拾",
    "拿",
    "拴",
    "拷",
    "拱",
    "拳",
    "拎",
    "拍",
    "拌",
    "拋",
    "拉",
    "拈",
    "拇",
    "拆",
    "担",
    "拄",
    "拂",
    "拟",
    "拜",
    "招",
    "拘",
    "拙",
    "拖",
    "拗",
    "拔",
    "拒",
    "拓",
    "拐",
    "抨",
    "披",
    "抬",
    "抡",
    "抠",
    "抢",
    "报",
    "护",
    "抹",
    "抺",
    "抻",
    "押",
    "抽",
    "抿",
    "抱",
    "抵",
    "把",
    "抉",
    "技",
    "抇",
    "抄",
    "抚",
    "抛",
    "折",
    "抒",
    "抓",
    "抑",
    "抖",
    "抗",
    "抔",
    "投",
    "扦",
    "执",
    "扣",
    "扬",
    "扭",
    "扮",
    "扯",
    "扩",
    "扪",
    "扫",
    "扶",
    "扰",
    "扳",
    "扽",
    "扼",
    "承",
    "找",
    "批",
    "扇",
    "所",
    "扁",
    "扎",
    "扌",
    "才",
    "手",
    "扈",
    "扉",
    "扔",
    "打",
    "扒",
    "扑",
    "扞",
    "扛",
    "托",
    "戡",
    "戢",
    "截",
    "戮",
    "戳",
    "戴",
    "户",
    "戸",
    "戽",
    "房",
    "戾",
    "戊",
    "戈",
    "戎",
    "戏",
    "戍",
    "戒",
    "我",
    "成",
    "或",
    "戚",
    "战",
    "戟",
    "揽",
    "揶",
    "揷",
    "援",
    "揭",
    "揪",
    "揩",
    "揣",
    "握",
    "揖",
    "提",
    "插",
    "揍",
    "描",
    "揉",
    "掳",
    "掰",
    "掷",
    "掴",
    "措",
    "掩",
    "推",
    "掬",
    "掣",
    "探",
    "掠",
    "控",
    "接",
    "掤",
    "掘",
    "掛",
    "掐",
    "排",
    "掖",
    "掉",
    "授",
    "掊",
    "掌",
    "掏",
    "掎",
    "掀",
    "掂",
    "捷",
    "捶",
    "捱",
    "捽",
    "捻",
    "捺",
    "捧",
    "换",
    "捣",
    "捡",
    "据",
    "捕",
    "捐",
    "损",
    "捞",
    "捅",
    "捆",
    "捁",
    "捂",
    "捍",
    "捎",
    "捏",
    "捉",
    "挲",
    "挺",
    "挽",
    "挣",
    "挠",
    "挡",
    "挤",
    "挥",
    "挪",
    "挫",
    "挨",
    "振",
    "挑",
    "挒",
    "挖",
    "挛",
    "挚",
    "挟",
    "持",
    "挂",
    "指",
    "按",
    "挎",
    "惋",
    "惊",
    "惇",
    "惆",
    "情",
    "惚",
    "惘",
    "惟",
    "惜",
    "惑",
    "惕",
    "惩",
    "惨",
    "惫",
    "惭",
    "惬",
    "惯",
    "惮",
    "惡",
    "惠",
    "惧",
    "惦",
    "惹",
    "惺",
    "惰",
    "想",
    "惴",
    "惶",
    "悍",
    "悌",
    "悉",
    "悄",
    "悟",
    "悚",
    "悖",
    "悔",
    "悬",
    "悯",
    "您",
    "悫",
    "悦",
    "悠",
    "患",
    "悼",
    "悸",
    "悻",
    "悴",
    "悱",
    "悲",
    "恃",
    "恁",
    "恋",
    "恍",
    "恒",
    "恐",
    "恕",
    "恙",
    "恡",
    "恢",
    "恣",
    "恤",
    "恨",
    "恩",
    "恪",
    "恬",
    "恭",
    "息",
    "恰",
    "恳",
    "恶",
    "恹",
    "恸",
    "恻",
    "恺",
    "恼",
    "恿",
    "怆",
    "怄",
    "怅",
    "怂",
    "怀",
    "态",
    "怎",
    "怏",
    "怖",
    "怕",
    "怔",
    "怒",
    "思",
    "怜",
    "怙",
    "急",
    "怦",
    "性",
    "怠",
    "怡",
    "怯",
    "怨",
    "怪",
    "怵",
    "怼",
    "总",
    "懒",
    "懔",
    "懈",
    "懊",
    "懂",
    "懿",
    "懦",
    "憝",
    "憔",
    "憎",
    "憋",
    "憇",
    "憾",
    "憨",
    "憧",
    "慑",
    "慕",
    "慈",
    "慌",
    "慎",
    "慰",
    "慷",
    "慵",
    "慢",
    "慧",
    "慨",
    "愕",
    "感",
    "愛",
    "愚",
    "愀",
    "愁",
    "愎",
    "意",
    "愈",
    "愉",
    "愿",
    "愦",
    "愧",
    "愤",
    "愣",
    "愠",
    "愫",
    "游",
    "渺",
    "渲",
    "渴",
    "温",
    "渭",
    "港",
    "渠",
    "渡",
    "渣",
    "渤",
    "渥",
    "渚",
    "渝",
    "渐",
    "渗",
    "渔",
    "渊",
    "渉",
    "渌",
    "渍",
    "渀",
    "清",
    "湿",
    "湾",
    "湮",
    "湫",
    "湟",
    "湛",
    "湘",
    "湖",
    "湓",
    "湎",
    "湍",
    "湄",
    "湃",
    "溶",
    "溺",
    "溢",
    "溥",
    "溪",
    "溯",
    "源",
    "溘",
    "溟",
    "溜",
    "溃",
    "溅",
    "溉",
    "溏",
    "滴",
    "滥",
    "滤",
    "滦",
    "满",
    "滢",
    "滩",
    "滨",
    "滖",
    "滔",
    "滕",
    "滓",
    "滑",
    "滞",
    "滟",
    "滚",
    "滂",
    "滋",
    "漫",
    "漩",
    "漠",
    "漾",
    "漳",
    "漱",
    "漏",
    "漁",
    "漂",
    "漆",
    "漓",
    "漕",
    "演",
    "潮",
    "潭",
    "潦",
    "潢",
    "潼",
    "潺",
    "潸",
    "潋",
    "潆",
    "潇",
    "潜",
    "潘",
    "澡",
    "澳",
    "澶",
    "澹",
    "澄",
    "澈",
    "澎",
    "澜",
    "濡",
    "濯",
    "激",
    "濒",
    "氟",
    "氛",
    "气",
    "氓",
    "民",
    "氐",
    "氏",
    "永",
    "水",
    "氦",
    "氧",
    "氢",
    "汛",
    "江",
    "汞",
    "汝",
    "汐",
    "汗",
    "汕",
    "汉",
    "求",
    "汀",
    "汁",
    "汆",
    "汇",
    "汹",
    "汽",
    "汾",
    "汰",
    "汲",
    "汶",
    "汨",
    "汩",
    "汪",
    "汭",
    "池",
    "污",
    "汤",
    "沒",
    "沓",
    "沐",
    "沟",
    "沛",
    "沙",
    "沆",
    "沅",
    "沃",
    "沂",
    "沁",
    "沏",
    "沌",
    "沉",
    "沈",
    "沵",
    "沱",
    "河",
    "沼",
    "沽",
    "沾",
    "沿",
    "沸",
    "油",
    "治",
    "沥",
    "沤",
    "沧",
    "沦",
    "没",
    "沢",
    "沬",
    "沮",
    "沨",
    "沫",
    "沪",
    "泓",
    "泗",
    "泔",
    "法",
    "泛",
    "泞",
    "泄",
    "泊",
    "泉",
    "泌",
    "泰",
    "泱",
    "泳",
    "泵",
    "泷",
    "泸",
    "泻",
    "泼",
    "泽",
    "泾",
    "泡",
    "泠",
    "泣",
    "波",
    "泥",
    "注",
    "泪",
    "泯",
    "泮",
    "洌",
    "洋",
    "洄",
    "洁",
    "洞",
    "洙",
    "洛",
    "洗",
    "洒",
    "洪",
    "洫",
    "津",
    "洢",
    "派",
    "洽",
    "洼",
    "活",
    "洹",
    "洵",
    "洲",
    "洱",
    "浊",
    "测",
    "济",
    "浏",
    "流",
    "浄",
    "浅",
    "浆",
    "浇",
    "浙",
    "浜",
    "浞",
    "浑",
    "浓",
    "浒",
    "浔",
    "浪",
    "浩",
    "浮",
    "浣",
    "浦",
    "浥",
    "浸",
    "浼",
    "海",
    "浴",
    "涅",
    "涂",
    "涌",
    "涎",
    "涉",
    "消",
    "涔",
    "涕",
    "涓",
    "涝",
    "涞",
    "涟",
    "涛",
    "涧",
    "润",
    "涤",
    "涣",
    "涡",
    "涯",
    "涮",
    "涫",
    "涩",
    "涨",
    "涵",
    "液",
    "涱",
    "涿",
    "涸",
    "淀",
    "淅",
    "淄",
    "淇",
    "淆",
    "淋",
    "淑",
    "淘",
    "淙",
    "淡",
    "淤",
    "淮",
    "淬",
    "淳",
    "深",
    "混",
    "添",
    "淹",
    "淼",
    "橱",
    "橹",
    "橙",
    "橘",
    "橄",
    "樱",
    "樵",
    "横",
    "樟",
    "樂",
    "樁",
    "樊",
    "檀",
    "武",
    "歧",
    "此",
    "步",
    "止",
    "正",
    "歪",
    "歩",
    "歼",
    "死",
    "歹",
    "歌",
    "歉",
    "欢",
    "欣",
    "欠",
    "次",
    "欧",
    "欲",
    "欺",
    "款",
    "毫",
    "毡",
    "毽",
    "母",
    "每",
    "毅",
    "毁",
    "毙",
    "毛",
    "比",
    "毕",
    "毖",
    "毗",
    "毒",
    "殡",
    "殺",
    "殿",
    "殴",
    "段",
    "殉",
    "残",
    "殊",
    "殁",
    "殃",
    "殂",
    "殄",
    "殇",
    "殆",
    "殘",
    "殚",
    "殒",
    "殓",
    "殖",
    "桓",
    "桑",
    "桐",
    "桔",
    "桂",
    "桃",
    "桀",
    "框",
    "桅",
    "案",
    "桎",
    "桌",
    "桴",
    "桷",
    "桶",
    "桠",
    "桡",
    "桢",
    "档",
    "桥",
    "桦",
    "桧",
    "桨",
    "桩",
    "栗",
    "栖",
    "栓",
    "树",
    "栝",
    "标",
    "栅",
    "栎",
    "栏",
    "栋",
    "栈",
    "栉",
    "样",
    "栽",
    "格",
    "栾",
    "根",
    "核",
    "校",
    "栩",
    "株",
    "棚",
    "棘",
    "棒",
    "棕",
    "棋",
    "棉",
    "棍",
    "棁",
    "检",
    "棺",
    "棵",
    "森",
    "棠",
    "梗",
    "梓",
    "梏",
    "梆",
    "梅",
    "梁",
    "梵",
    "械",
    "梳",
    "梨",
    "梧",
    "梦",
    "梢",
    "楂",
    "楔",
    "楚",
    "楞",
    "楣",
    "楠",
    "楫",
    "楷",
    "楴",
    "楼",
    "椅",
    "椁",
    "植",
    "椎",
    "椋",
    "椐",
    "椒",
    "椰",
    "椿",
    "椽",
    "椹",
    "槊",
    "槌",
    "槁",
    "槃",
    "槛",
    "槐",
    "槿",
    "槽",
    "榉",
    "榈",
    "榄",
    "榆",
    "榔",
    "榕",
    "榻",
    "瞑",
    "瞟",
    "瞄",
    "瞅",
    "瞋",
    "瞌",
    "瞎",
    "瞳",
    "瞠",
    "瞧",
    "瞥",
    "瞪",
    "瞩",
    "瞬",
    "瞭",
    "矜",
    "矛",
    "矅",
    "石",
    "矿",
    "知",
    "矢",
    "矣",
    "矮",
    "矬",
    "短",
    "矫",
    "矩",
    "眙",
    "真",
    "眉",
    "眈",
    "看",
    "省",
    "眇",
    "眺",
    "眸",
    "眼",
    "眶",
    "眷",
    "眩",
    "眨",
    "眯",
    "眬",
    "眠",
    "睛",
    "睑",
    "睁",
    "着",
    "睿",
    "睽",
    "睬",
    "睫",
    "睥",
    "督",
    "睢",
    "睡",
    "皂",
    "皆",
    "皇",
    "的",
    "皋",
    "皈",
    "－",
    "皎",
    "皓",
    "皑",
    "皐",
    "皖",
    "皙",
    "皮",
    "皱",
    "皿",
    "盆",
    "盅",
    "盂",
    "盎",
    "盏",
    "益",
    "盈",
    "盗",
    "盖",
    "盔",
    "盒",
    "监",
    "盐",
    "盟",
    "盛",
    "盘",
    "盥",
    "目",
    "盯",
    "直",
    "盱",
    "盲",
    "盼",
    "盾",
    "盹",
    "相",
    "瘟",
    "白",
    "百",
    "癸",
    "登",
    "疵",
    "疴",
    "疲",
    "疾",
    "疼",
    "疤",
    "疮",
    "疯",
    "疫",
    "疗",
    "疑",
    "疟",
    "疆",
    "疏",
    "痴",
    "痩",
    "痒",
    "痕",
    "痔",
    "痘",
    "痛",
    "痂",
    "病",
    "症",
    "痉",
    "町",
    "画",
    "甸",
    "男",
    "电",
    "甲",
    "申",
    "田",
    "由",
    "甭",
    "甬",
    "甫",
    "甩",
    "用",
    "甜",
    "生",
    "甘",
    "甚",
    "甄",
    "畸",
    "當",
    "番",
    "畦",
    "略",
    "留",
    "畜",
    "畔",
    "界",
    "畏",
    "畅",
    "璧",
    "璇",
    "璃",
    "璀",
    "璎",
    "璋",
    "璐",
    "璟",
    "璞",
    "璜",
    "瓢",
    "瓣",
    "瓦",
    "瓮",
    "瓷",
    "瓶",
    "瓘",
    "瓜",
    "琭",
    "琮",
    "琨",
    "琪",
    "琥",
    "琤",
    "琦",
    "琢",
    "琼",
    "琴",
    "琵",
    "琶",
    "琰",
    "琳",
    "琊",
    "琉",
    "理",
    "琅",
    "球",
    "琚",
    "琛",
    "琐",
    "瑭",
    "瑣",
    "瑾",
    "瑰",
    "瑶",
    "瑎",
    "瑁",
    "瑚",
    "瑛",
    "瑙",
    "瑞",
    "瑟",
    "瑜",
    "瑕",
    "珞",
    "珑",
    "珍",
    "珏",
    "珊",
    "珅",
    "珀",
    "珂",
    "珰",
    "珮",
    "班",
    "珥",
    "珠",
    "玛",
    "玟",
    "玑",
    "玖",
    "玉",
    "王",
    "玎",
    "玄",
    "率",
    "玻",
    "玺",
    "玲",
    "现",
    "玷",
    "玫",
    "玩",
    "玮",
    "环",
    "玦",
    "玥",
    "獒",
    "獴",
    "獾",
    "猕",
    "猖",
    "猛",
    "猜",
    "猝",
    "猎",
    "猴",
    "猿",
    "猢",
    "猫",
    "猪",
    "献",
    "猬",
    "狍",
    "狈",
    "狄",
    "狂",
    "狒",
    "狐",
    "独",
    "狭",
    "狮",
    "狩",
    "狠",
    "狡",
    "狼",
    "狸",
    "狻",
    "狴",
    "狷",
    "狱",
    "狰",
    "狲",
    "犊",
    "犀",
    "犁",
    "犬",
    "犯",
    "状",
    "片",
    "牌",
    "版",
    "牟",
    "牛",
    "牙",
    "牧",
    "牦",
    "牡",
    "牢",
    "物",
    "牵",
    "牲",
    "特",
    "牺",
    "爁",
    "爆",
    "爪",
    "爬",
    "爵",
    "父",
    "爷",
    "爸",
    "爹",
    "爽",
    "燥",
    "燕",
    "燎",
    "燃",
    "熹",
    "熵",
    "熬",
    "熨",
    "熠",
    "熟",
    "熙",
    "熔",
    "熏",
    "熊",
    "熄",
    "煲",
    "煸",
    "煽",
    "照",
    "煦",
    "煤",
    "煨",
    "煮",
    "煜",
    "煞",
    "煅",
    "煊",
    "煌",
    "煎",
    "然",
    "焰",
    "焱",
    "焦",
    "無",
    "焠",
    "焕",
    "焖",
    "焘",
    "焙",
    "焚",
    "焉",
    "焊",
    "烨",
    "烩",
    "烫",
    "烬",
    "热",
    "烯",
    "烤",
    "烦",
    "烧",
    "烹",
    "烽",
    "烷",
    "烊",
    "烈",
    "烏",
    "烂",
    "烁",
    "烛",
    "烙",
    "烘",
    "烟",
    "烜",
    "烔",
    "炬",
    "炭",
    "炮",
    "炯",
    "炫",
    "炽",
    "炼",
    "点",
    "炸",
    "為",
    "炷",
    "炳",
    "炎",
    "炊",
    "炉",
    "炆",
    "炅",
    "炀",
    "炁",
    "炜",
    "炙",
    "炖",
    "炕",
    "炔",
    "炒",
    "火",
    "灭",
    "灯",
    "灰",
    "灵",
    "灶",
    "灸",
    "灼",
    "灾",
    "灿",
    "灌",
    "瀑",
    "瀚",
    "瀛",
    "缉",
    "缈",
    "缍",
    "缎",
    "缁",
    "缀",
    "缃",
    "缅",
    "缄",
    "缇",
    "缆",
    "缘",
    "缚",
    "缜",
    "缝",
    "缓",
    "缕",
    "编",
    "缪",
    "缩",
    "缨",
    "缮",
    "缭",
    "缢",
    "缠",
    "缥",
    "缤",
    "缺",
    "缸",
    "缰",
    "缴",
    "罂",
    "罚",
    "罔",
    "罕",
    "罗",
    "罐",
    "网",
    "置",
    "罪",
    "罩",
    "罢",
    "罡",
    "罹",
    "署",
    "羁",
    "羊",
    "羌",
    "美",
    "羔",
    "羚",
    "羝",
    "羞",
    "羡",
    "羧",
    "群",
    "羨",
    "羯",
    "羹",
    "羿",
    "羽",
    "翅",
    "翁",
    "翌",
    "翎",
    "翊",
    "翕",
    "翔",
    "翟",
    "翘",
    "翦",
    "翠",
    "翡",
    "翱",
    "翰",
    "翼",
    "翻",
    "繁",
    "纱",
    "纳",
    "纲",
    "纵",
    "纷",
    "纶",
    "纹",
    "纸",
    "纺",
    "纽",
    "线",
    "纾",
    "纠",
    "纡",
    "红",
    "纣",
    "纤",
    "纥",
    "约",
    "级",
    "纨",
    "纩",
    "纪",
    "纫",
    "纬",
    "纯",
    "绕",
    "绔",
    "结",
    "绒",
    "绑",
    "统",
    "绞",
    "绝",
    "络",
    "绛",
    "绚",
    "给",
    "绘",
    "细",
    "织",
    "组",
    "绅",
    "练",
    "绀",
    "绎",
    "经",
    "绌",
    "绍",
    "绊",
    "终",
    "绉",
    "绵",
    "维",
    "绷",
    "绰",
    "绳",
    "绽",
    "综",
    "绿",
    "绾",
    "绸",
    "绻",
    "绥",
    "继",
    "绡",
    "绢",
    "绣",
    "续",
    "绮",
    "绯",
    "绨",
    "绩",
    "绪",
    "绫",
    "累",
    "紫",
    "紧",
    "索",
    "素",
    "紊",
    "絮",
    "緒",
    "簿",
    "簸",
    "簪",
    "簧",
    "簌",
    "簇",
    "类",
    "籽",
    "米",
    "籍",
    "籃",
    "籁",
    "粱",
    "粽",
    "精",
    "粹",
    "粤",
    "粥",
    "粢",
    "粮",
    "粪",
    "粗",
    "粕",
    "粒",
    "粑",
    "粟",
    "粝",
    "粘",
    "粉",
    "系",
    "糠",
    "糯",
    "糗",
    "糖",
    "糕",
    "糙",
    "糟",
    "糜",
    "糁",
    "糅",
    "糊",
    "糍",
    "筆",
    "筏",
    "等",
    "筋",
    "答",
    "策",
    "筐",
    "筑",
    "筒",
    "筝",
    "筚",
    "筛",
    "筠",
    "筮",
    "筷",
    "筵",
    "签",
    "筹",
    "笃",
    "笆",
    "笈",
    "笋",
    "笏",
    "笑",
    "笔",
    "笙",
    "笛",
    "笞",
    "笠",
    "符",
    "笨",
    "第",
    "笺",
    "笼",
    "篆",
    "篇",
    "篮",
    "篡",
    "篷",
    "篱",
    "简",
    "箔",
    "算",
    "箫",
    "箭",
    "管",
    "箱",
    "穗",
    "穆",
    "穴",
    "究",
    "穷",
    "穿",
    "穹",
    "空",
    "稚",
    "稞",
    "程",
    "税",
    "稍",
    "稳",
    "稻",
    "稣",
    "竟",
    "竞",
    "站",
    "竖",
    "立",
    "竽",
    "竿",
    "竹",
    "竭",
    "端",
    "童",
    "竦",
    "章",
    "竣",
    "窘",
    "窟",
    "窝",
    "窜",
    "窒",
    "窑",
    "窗",
    "窖",
    "窕",
    "窈",
    "窍",
    "窃",
    "突",
    "窄",
    "窿",
    "窥",
    "窦",
    "祢",
    "祠",
    "祥",
    "票",
    "祯",
    "祭",
    "祷",
    "祸",
    "祼",
    "祁",
    "祀",
    "祂",
    "祉",
    "祈",
    "祍",
    "祐",
    "祖",
    "祗",
    "祚",
    "祛",
    "祝",
    "神",
    "祟",
    "社",
    "礼",
    "示",
    "礁",
    "秩",
    "积",
    "秭",
    "秣",
    "秦",
    "秧",
    "秤",
    "移",
    "秸",
    "秾",
    "秽",
    "称",
    "秉",
    "秋",
    "种",
    "秀",
    "私",
    "秃",
    "秆",
    "秘",
    "租",
    "科",
    "秒",
    "禧",
    "禾",
    "禽",
    "离",
    "禺",
    "禹",
    "福",
    "禄",
    "禅",
    "禇",
    "禀",
    "禁",
    "硫",
    "硬",
    "确",
    "硕",
    "硝",
    "破",
    "砰",
    "砾",
    "砸",
    "砺",
    "砥",
    "砖",
    "研",
    "码",
    "砍",
    "砌",
    "磺",
    "磷",
    "磨",
    "磬",
    "磐",
    "磕",
    "磊",
    "磁",
    "碾",
    "確",
    "碰",
    "碳",
    "碧",
    "碘",
    "碗",
    "碑",
    "碍"
];


// WEBPACK FOOTER //
// ./src/components/data.js